import React from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Container, Row, Col, ListGroup, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Blog from './components/Blog';
import Resume from './components/Resume';
import Github from './components/Github';
import BthereDotAI from './components/BthereDotAI';
import sm_lilac from './assets/img/stuart_lilac.jpg';

function App(): React.JSX.Element {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <p>Stuart Marshall</p>
        </header>
        <Container>
          <Row className="pt-3">
            <Col>
              <Routes>
                <Route path="/" element={<Blog />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/bthere" element={<BthereDotAI />} />
                <Route path="/github" element={<Github />} />
              </Routes>
            </Col>
            <Col xl={2} lg={2} md={2} sm={2} className="ps-5">
              <Image
                fluid
                src={sm_lilac}
                alt="Stuart Marshall"
                className="mb-3"
              />
              <ListGroup variant="flush">
                <ListGroup.Item action as={Link} to="/">
                  Blog
                </ListGroup.Item>
                <ListGroup.Item action as={Link} to="/resume">
                  Resume
                </ListGroup.Item>
                <ListGroup.Item action as={Link} to="/bthere">
                  bThere.ai
                </ListGroup.Item>
                <ListGroup.Item action as={Link} to="/github">
                  Github
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </div>
    </Router>
  );
}

export default App;
